<ng-container *ngIf="banner$ | async as data">
  <ng-container *ngIf="data.urlLink?.length; else noLink">
    <cx-generic-link [url]="data.urlLink" [target]="data.external ? '_blank' : null" (click)="onBannerClick()">
      <ng-container *ngTemplateOutlet="bannerContent; context: { data: data }"></ng-container>
    </cx-generic-link>
  </ng-container>
  <ng-template #noLink>
    <ng-container *ngTemplateOutlet="bannerContent; context: { data: data }"></ng-container>
  </ng-template>

  <ng-template #bannerContent>
    <sd-banner-content
      [responsiveBannerData]="data"
      [sdInViewport]="0.5"
      [intersectedOnce]="true"
      (intersected)="onBannerIntersect()"
    ></sd-banner-content>
  </ng-template>
  <span class="clock">{{ this.clock | date: 'd MMMM HH:mm' }}</span>
</ng-container>
